import React from "react";
import HeaderMenuItem from "./HeaderMenuItem"

function HeaderMenu(props) {
  //console.log('props in HeaderMenu: ', props);
  let headerMenuItems = props.data.map(
    el => {
      return ( <HeaderMenuItem key={ el.img_path} data={ el } /> )
    }
  );
  return (
    <li className="nav-item dropdown">
      <a
        className="nav-link dropdown-toggle"
        href="#index"
        id="navbarDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        { props.name }
      </a>
      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">        
        { headerMenuItems }
      </ul>
    </li>
  );
}

export default HeaderMenu;
